import React, { useContext, useEffect, useState } from 'react';
import {
  // Card,
  Typography,
  Box,
  Button,
  Pagination,
  // useTheme,
} from '@mui/material';
// import { BiTime } from 'react-icons/bi';
// import { FaQuoteLeft, FaQuoteRight } from 'react-icons/fa';
import { ReviewContext } from './ReviewContext';
import { motion, AnimatePresence } from 'framer-motion';
// import { Link } from 'react-router-dom';
import { showSwalNotification } from '../utils/SwalResponse';
// import UpdateReviewForm from './forms/UpdateReviewForm';
import LoadingComponent from '../utils/LoadingComponent';
import ReviewCard from './ReviewCard';


const REVIEWS_PER_PAGE = 6;
// const MotionCard = motion(Card);

const MyReviews = () => {
  const { loading, fetchMyReviews } = useContext(ReviewContext);
  const [reviews, setReviews] = useState([]);
  const [page, setPage] = useState(1);
  // const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [reload, setReload] = useState(false)

  // const theme = useTheme();

  const fetchData = async () => {
    const response = await fetchMyReviews()
    if (response?.status === 'success'){
        setReviews(response.data)
    }else{
        showSwalNotification(response)
    }
}
  useEffect(() => {
    
    fetchData()
    
  }, [reload])
  

  const handleChangePage = (event, value) => setPage(value);

  


  const startIdx = (page - 1) * REVIEWS_PER_PAGE;
  const paginatedReviews = Array.isArray(reviews) && reviews.slice(startIdx, startIdx + REVIEWS_PER_PAGE);

  if (!!loading) return <LoadingComponent loadingText={'Loading Your reviews ....'} />
  return (
    <Box className="py-5 px-3 position-relative">
      <Typography
        variant="h4"
        className="mb-5 text-center fw-bold"
        sx={{
          color: '#fff',
          textTransform: 'uppercase',
          letterSpacing: 1,
        }}
      >
        My Reviews
      </Typography>

   
    <Button
        variant="outlined"
        color="error"
        onClick={()=> window.history.back()}
        sx={{ position: 'absolute', top: 16, right: 16 }}
      >
        ❌
      </Button>

{/* <UpdateReviewForm
        open={openModal}
        onClose={() => setOpenModal(false)}
        review={selectedReview}
        reload = {reload}
        setReload={setReload}
        /> */}

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: 4,
        }}
      >

        <AnimatePresence>
          {(Array.isArray(paginatedReviews) && paginatedReviews.length > 0 )? paginatedReviews.map((review, index) => (
            <ReviewCard review={review} reload={reload} setReload={setReload}/>
            // <MotionCard
            //   key={index}
            //   elevation={6}
            //   initial={{ opacity: 0, y: 40 }}
            //   animate={{ opacity: 1, y: 0 }}
            //   exit={{ opacity: 0, y: 40 }}
            //   transition={{ delay: index * 0.15, duration: 0.6, type: 'spring' }}
            //   sx={{
            //     width: isMobile ? '100%' : 'calc(33% - 2rem)',
            //     minWidth: 300,
            //     borderRadius: 4,
            //     border: '1px solid #c8e6c9',
            //     background: 'linear-gradient(135deg, #ffffff, #e0f2f1)',
            //     color: '#1b5e20',
            //     boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
            //     display: 'flex',
            //     flexDirection: 'column',
            //   }}
            // >
            //   <CardHeader
            //     avatar={
            //       <Avatar
            //         src={
            //           review.profile ||
            //           'https://t4.ftcdn.net/jpg/01/97/15/87/360_F_197158744_1NBB1dEAHV2j9xETSUClYqZo7SEadToU.jpg'
            //         }
            //         sx={{ width: 56, height: 56 }}
            //       />
            //     }
            //     title={
            //       <Box display="flex" justifyContent="space-between">
            //         <Typography variant="h6" color="success.dark">
            //           {review.user?.name || 'Anonymous'}
            //         </Typography>
            //         <Typography variant="caption" color="text.secondary">
            //           <BiTime className="me-1" />
            //           {new Date(review.timestamp).toLocaleString()}
            //         </Typography>
            //       </Box>
            //     }
            //     subheader={
            //       <Typography variant="caption">
            //         Issue:{' '}
            //         <Link to={`/issues/${review.issue_id}`}>
            //           <strong>{review.issue_id}</strong>
            //         </Link>{' '}
            //         ({review.issue_status || 'Open'})
            //       </Typography>
            //     }
            //   />

            //   <CardContent sx={{ flexGrow: 1 }}>
            //     <Typography
            //       variant="body1"
            //       fontStyle="italic"
            //       sx={{ position: 'relative', mb: 2, px: 2, whiteSpace: 'pre-wrap' }}
            //     >
            //       <FaQuoteLeft className="me-2 text-success" />
            //       {review.review_text}
            //       <FaQuoteRight className="ms-2 text-success" />
            //     </Typography>

            //     <Box className="d-flex justify-content-center fs-4 mb-2">
            //       <Rating value={review.rating || 0} readOnly precision={0.5} />
            //     </Box>

            //     {review.reply && (
            //       <Box className="px-3 py-3 mt-4 rounded-4 border border-success bg-light">
            //         <div className="d-flex align-items-center gap-3 mb-2">
            //           <Avatar
            //             src={
            //               review.reply.admin?.profile ||
            //               'https://picsum.photos/1017/917'
            //             }
            //             sx={{ width: 40, height: 40 }}
            //           />
            //           <Box>
            //             <Typography variant="subtitle2" className="fw-bold">
            //               {review.reply.admin?.name || 'Admin'} —{' '}
            //               {review.reply.admin?.organisation || 'Administration'}
            //             </Typography>
            //             <Typography variant="caption" className="text-muted">
            //               <BiTime className="me-1" />
            //               {new Date(review.reply.replied_at).toLocaleString()}
            //             </Typography>
            //           </Box>
            //         </div>
            //         <Divider className="mb-2" />
            //         <Typography variant="body2" className="text-dark" sx={{ whiteSpace: 'pre-wrap' }}>
            //           {review.reply.reply_text}
            //         </Typography>
            //       </Box>
            //     )}
            //   </CardContent>

            //   <Box sx={{ display: 'flex', justifyContent: 'start', p: 2 }}>
              
            //     <Button
            //       variant="outlined"
            //       color="success"
            //       size="small"
            //       onClick={() => handleUpdate(review)}
            //     >
            //       Update
            //     </Button>

            //     {/* <Button
            //       variant="outlined"
            //       color="error"
            //       size="small"
            //       onClick={() => handleDelete(review)}
            //     >
            //       Delete
            //     </Button> */}
            //   </Box>
            // </MotionCard>
          )) :(<div className='container text-center fs-5 alert alert-info'>You have not made any reviews yet</div>)}
        </AnimatePresence>
      </Box>

      <Box className="d-flex justify-content-center mt-5">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Pagination
            count={Math.ceil(reviews.length / REVIEWS_PER_PAGE)}
            page={page}
            onChange={handleChangePage}
            color="primary"
          />
        </motion.div>
      </Box>


    </Box>
  );
};

export default MyReviews;
